import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en';
import ru from './locales/ru';

const RUSSIAN_LIKE = new Set(['ru', 'uk', 'be', 'kk', 'ky']);

function detectFromTelegram(): string | null {
  if (typeof window === 'undefined') return null;
  const code = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  if (!code) return null;
  return RUSSIAN_LIKE.has(code) ? 'ru' : 'en';
}

const telegramLang = detectFromTelegram();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ru: { translation: ru },
    },
    fallbackLng: 'en',
    lng: telegramLang ?? undefined,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

export default i18n;
